import React, { ChangeEvent, useState } from 'react';
import { AgreementCheckbox } from 'shared/aggreement/AgreementCheckbox';
import { useElementId } from 'shared/utils/elementIds';
import { App_ApplicationFragment, App_PortalFragment, useSetAcceptedAgreementMutation } from '../../generated.graphql';


interface CheckboxesProps {
  portal: App_PortalFragment
  application: App_ApplicationFragment
}


export const AgreementCheckboxes = (props: CheckboxesProps) => {
  const applicationAccepted = !!props.application.acceptedAgreement;
  const agreement1Id = useElementId('agreement1');
  const agreement2Id = useElementId('agreement2');
  const marketingId = useElementId('marketingConsent');
  const [checked, setChecked] = useState({
    [agreement1Id]: applicationAccepted,
    [agreement2Id]: applicationAccepted,
    [marketingId]: props.application.marketingConsent
  })
  const [, mutate] = useSetAcceptedAgreementMutation();

  const acceptAgreementWhenChecked = [agreement1Id, agreement2Id];
  const isAgreementComplete = (checkedState: { [key: string]: boolean }) => {
    return acceptAgreementWhenChecked
      .every((k) => checked.hasOwnProperty(k) && checkedState[k]);
  }

  const onCheckChanged = (e: ChangeEvent<HTMLInputElement>) => {
    const newCheckedState = {
      ...checked,
      [e.target.name]: e.target.checked,
    };
    const accepted = isAgreementComplete(newCheckedState);

    if (isAgreementComplete(checked) !== accepted ||
        checked[marketingId] !== newCheckedState[marketingId])
    {
      // if the agreement completion state changes, or marketing consent changes, mutate
      mutate({
        input: {
          portalSlug: props.application.portal.slug,
          accepted,
          marketingConsent: newCheckedState[marketingId] ?? false,
        },
      })
    }

    setChecked(newCheckedState);
  }

  // 2021-08-09: previously had different wording for in-store, but has since been removed
  return (
    <>
      <AgreementCheckbox
        elementId={agreement1Id}
        checked={checked[agreement1Id]}
        onChange={onCheckChanged}
      >
        I have read and agree to the Terms and Conditions.
      </AgreementCheckbox>
      <AgreementCheckbox
        elementId={agreement2Id}
        checked={checked[agreement2Id]}
        onChange={onCheckChanged}
      >
        I acknowledge that this application is subject to an approval process and the Polygon Group may obtain a credit report from a Credit Reporting Body.
      </AgreementCheckbox>
    </>
  )
}